import { ArrowRight } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ActionCardProps {
  title: string;
  description?: string;
  onClick?: () => void;
}

export function ActionCard({ title, description, onClick }: ActionCardProps) {
  return (
    <Card
      className="p-4 cursor-pointer hover:bg-gray-100 transition-colors gap-2 flex flex-col h-full"
      onClick={onClick}
    >
      <div className="p-0 flex flex-row items-center justify-between">
        <CardTitle
          className="font-semibold text-gray-900"
          style={{ fontSize: "16px" }}
        >
          {title}
        </CardTitle>
        <div className="w-6 h-5 bg-black rounded-full flex items-center justify-center flex-shrink-0">
          <ArrowRight className="text-white text-xs font-medium" size={14} />
        </div>
      </div>
      {description && (
        <div className="p-0">
          <p
            className="font-light text-gray-600 truncate"
            style={{ fontSize: "13px" }}
          >
            {description}
          </p>
        </div>
      )}
    </Card>
  );
}
